import { instance, next } from "./base";

const BASE = "/api/v1/admin/bvn-watchlist";

export const getWatchlist = async (params) => {
  const { data } = await instance()
    .get(BASE, { params })
    .catch((e) => next(e));
  return data?.data;
};

export const getWatchlistSummary = async () => {
  const { data } = await instance()
    .get(`${BASE}/summary`)
    .catch((e) => next(e));
  return data?.data;
};

export const addWatchlistBvn = async (values) => {
  const { data } = await instance()
    .post(BASE, values)
    .catch((e) => next(e));
  return data;
};

export const uploadWatchlistCsv = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await instance(true)
    .post(`${BASE}/upload`, form)
    .catch((e) => next(e));
  return data;
};

export const removeWatchlistBvn = async (id) => {
  const { data } = await instance()
    .delete(`${BASE}/${id}`)
    .catch((e) => next(e));
  return data;
};
